import React from "react";

export const EnableColorsContext = React.createContext<boolean>(false);

export function useEnableColors() {
  return React.useContext(EnableColorsContext);
}
